const STORAGE_KEY = 'sport-rev-iframe:pinnedMarkets';

export function loadPinnedMarkets() {
  try {
    return JSON.parse(localStorage.getItem(STORAGE_KEY) || '[]');
  } catch {
    return [];
  }
}

export function savePinnedMarkets(marketIds) {
  try {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(marketIds));
  } catch {
    // quota exceeded or storage blocked — silently ignore
  }
}
